import { REACT_QUERY_KEYS } from '@/constants'

import { type FetchShipmentOrderImportFormatsQuery } from './api'

export const shipmentOrderImportFormatsQueryKeys = {
  all: [REACT_QUERY_KEYS.SHIPMENT_ORDER_IMPORT_FORMATS] as const,
  list: (query: FetchShipmentOrderImportFormatsQuery) =>
    [...shipmentOrderImportFormatsQueryKeys.all, 'list', query] as const
}
